import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import VisibilitySensor from 'react-visibility-sensor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrophy,
  faPuzzlePiece,
  faClock,
  faArrowTrendUp,
  faBolt,
  faSyncAlt,
} from '@fortawesome/free-solid-svg-icons';
import 'animate.css';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import WhoWeAreLayoutSelector from '../HomeComponents/WhoWeAreLayoutSelector';
import './Main.css';
import '../HomeComponents/About2.css';

/* --- Inlined: CTALayoutBanner (no external component import) --- */
function CTALayoutBannerInlined() {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);

  return (
    <VisibilitySensor onChange={(visible) => visible && !isVisible && setIsVisible(true)} partialVisibility>
      <section
        className="position-relative overflow-hidden"
        style={{
          background: 'var(--brand-green-dark)',
          paddingTop: '2rem',
          paddingBottom: '2rem',
          marginBottom: 0,
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8">
              <motion.div
                className="text-center text-white"
                initial={{ opacity: 0, y: 20 }}
                animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6 }}
              >
                <h3 className="text-white mb-3" style={{ fontSize: '1.6rem', fontWeight: '600' }}>
                  Ready to Transform Your Healthcare Operations?
                </h3>
                <p className="text-white mb-4" style={{ fontSize: '1rem', opacity: 0.9, marginBottom: '1.5rem !important' }}>
                  Join thousands of healthcare providers who trust our solutions to power their operations.
                </p>
                <div className="d-flex flex-wrap justify-content-center" style={{ gap: '1rem' }}>
                  <motion.a
                    href="/request-a-demo"
                    className="btn cta-btn-primary"
                    style={{
                      background: 'var(--brand-green-primary)',
                      color: 'white',
                      padding: '0.65rem 1.75rem',
                      borderRadius: '6px',
                      fontWeight: '600',
                      border: 'none',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      display: 'inline-block',
                      position: 'relative',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                    }}
                    initial={{ opacity: 0, x: -20 }}
                    animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(78, 143, 90, 0.4)' }}
                    whileTap={{ scale: 0.95 }}
                    onMouseEnter={() => setHoveredButton('primary')}
                    onMouseLeave={() => setHoveredButton(null)}
                  >
                    <span style={{ position: 'relative', zIndex: 1, color: '#ffffff !important' }}>Request a Demo</span>
                    {hoveredButton === 'primary' && (
                      <motion.div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: '-100%',
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
                          zIndex: 0,
                        }}
                        animate={{ left: '100%' }}
                        transition={{ duration: 0.6 }}
                      />
                    )}
                  </motion.a>
                  <motion.a
                    href="/contact-us"
                    className="btn cta-btn-secondary"
                    style={{
                      background: 'transparent',
                      color: 'white',
                      padding: '0.65rem 1.75rem',
                      borderRadius: '6px',
                      fontWeight: '600',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      display: 'inline-block',
                      position: 'relative',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                    }}
                    initial={{ opacity: 0, x: 20 }}
                    animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    whileHover={{
                      scale: 1.05,
                      background: 'rgba(255, 255, 255, 0.1)',
                      borderColor: 'rgba(255, 255, 255, 0.5)',
                      boxShadow: '0 8px 20px rgba(255, 255, 255, 0.2)',
                    }}
                    whileTap={{ scale: 0.95 }}
                    onMouseEnter={() => setHoveredButton('secondary')}
                    onMouseLeave={() => setHoveredButton(null)}
                  >
                    <span style={{ position: 'relative', zIndex: 1, color: '#ffffff !important' }}>Contact Us</span>
                    {hoveredButton === 'secondary' && (
                      <motion.div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: '-100%',
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
                          zIndex: 0,
                        }}
                        animate={{ left: '100%' }}
                        transition={{ duration: 0.6 }}
                      />
                    )}
                  </motion.a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
        <style>{`
          .cta-btn-primary, .cta-btn-primary:hover, .cta-btn-primary:active, .cta-btn-primary:focus { color: #ffffff !important; }
          .cta-btn-primary span { color: #ffffff !important; }
          .cta-btn-primary:hover { transform: translateY(-2px); }
          .cta-btn-secondary, .cta-btn-secondary:hover, .cta-btn-secondary:active, .cta-btn-secondary:focus { color: #ffffff !important; }
          .cta-btn-secondary span { color: #ffffff !important; }
          .cta-btn-secondary:hover { transform: translateY(-2px); }
          @media (max-width: 768px) {
            .cta-btn-primary, .cta-btn-secondary { width: 100%; max-width: 280px; }
          }
        `}</style>
      </section>
    </VisibilitySensor>
  );
}

function CompanyOverview() {
  document.title = "Company Overview :: D-Right Technologies";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [wcuVisible, setWcuVisible] = useState(false);
  const [wcuShowAll, setWcuShowAll] = useState(false);
  const [wcuIsMobile, setWcuIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setWcuIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const whyChooseUsItems = [
    { icon: faTrophy, title: 'Trusted Track Record', description: 'Years of experience in healthcare technology with a deep understanding of industry needs and challenges.' },
    { icon: faPuzzlePiece, title: 'End-to-End Solutions', description: 'Software that covers every aspect of healthcare operations from lab management to pharmacy systems.' },
    { icon: faClock, title: '24/7 Support', description: 'Round-the-clock customer support to ensure you get the most out of our solutions and resolve issues quickly.' },
    { icon: faArrowTrendUp, title: 'Future-Proof Technology', description: 'Solutions that grow with your business, from small clinics to large healthcare networks.' },
    { icon: faBolt, title: 'Effortless to Use', description: 'Intuitive interfaces designed with healthcare professionals in mind for easy adoption and efficient workflows.' },
    { icon: faSyncAlt, title: 'Always Improving', description: 'Regular updates and new features based on industry trends and customer feedback to keep you ahead.' },
  ];

  const displayedWcuItems = wcuIsMobile && !wcuShowAll ? whyChooseUsItems.slice(0, 3) : whyChooseUsItems;

  const whyChooseUsSectionStyle = {
    background: '#f8f9fa',
    paddingTop: '2.5rem',
    paddingBottom: '60px',
  };

  return (
    <>
      <Header />
      <div className="main no-banner-top-padding" style={{ background: '#f8f9fa' }}>
        <section
          className="page-header-section ptb-100 bg-image"
          image-overlay="8"
        >
          <div
            className="background-image-wraper"
            style={{
              background: `url('/assets/img/slider-bg-1.jpg')`,
              opacity: "1",
            }}
          ></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9 col-lg-7">
                <div className="page-header-content text-white pt-4">
                  <h1 className="text-white mb-0">Company Overview</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <WhoWeAreLayoutSelector />

        <section className="position-relative overflow-hidden ptb-100 gray-light-bg why-choose-us-section operational-excellence-section" style={whyChooseUsSectionStyle}>
          <div className="container" style={{ maxWidth: '1140px', width: '100%', margin: '0 auto', paddingLeft: '15px', paddingRight: '15px' }}>
            <div className="section-heading text-center mb-5">
              <h2 className="web">Why Choose Us</h2>
              <p>We stand out through our commitment to quality, innovation, and customer success.</p>
            </div>

            <VisibilitySensor onChange={(visible) => visible && !wcuVisible && setWcuVisible(true)} partialVisibility>
              <div className="row">
                {displayedWcuItems.map((item, index) => (
                  <div key={item.title} className="col-md-6 col-lg-4 mb-4">
                    <div
                      className={`feature-box-about2 ${wcuVisible ? 'animate__animated animate__slideInUp' : ''}`}
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <div className="feature-box-header-about2">
                        <FontAwesomeIcon icon={item.icon} />
                        <h5>{item.title}</h5>
                      </div>
                      <div className="feature-box-body-about2">
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </VisibilitySensor>

            {wcuIsMobile && (
              <div className="text-center mt-4">
                <button
                  className="btn-view-all"
                  onClick={() => setWcuShowAll(!wcuShowAll)}
                >
                  {wcuShowAll ? 'View Less' : 'View More'}
                </button>
              </div>
            )}
          </div>
          <style>{`
            @media (max-width: 768px) {
              .why-choose-us-section { padding-top: 20px !important; }
            }
            @media (max-width: 576px) {
              .why-choose-us-section { padding-top: 16px !important; }
            }
          `}</style>
        </section>

        <CTALayoutBannerInlined />
      </div>
      <Footer />

      {/* Ensure consistent container width across Company Overview page */}
      <style>{`
        /* Force consistent container width matching Web Builder page */
        .main .container,
        .main section .container,
        .wwa-section .container,
        .layout-options-section .container,
        .why-choose-us-section .container {
          max-width: 1140px !important;
          width: 100% !important;
          margin-left: auto !important;
          margin-right: auto !important;
          padding-left: 15px !important;
          padding-right: 15px !important;
        }

        @media (min-width: 576px) {
          .main .container,
          .main section .container,
          .wwa-section .container,
          .layout-options-section .container,
          .why-choose-us-section .container {
            max-width: 540px !important;
          }
        }

        @media (min-width: 768px) {
          .main .container,
          .main section .container,
          .wwa-section .container,
          .layout-options-section .container,
          .why-choose-us-section .container {
            max-width: 720px !important;
          }
        }

        @media (min-width: 992px) {
          .main .container,
          .main section .container,
          .wwa-section .container,
          .layout-options-section .container,
          .why-choose-us-section .container {
            max-width: 960px !important;
          }
        }

        @media (min-width: 1200px) {
          .main .container,
          .main section .container,
          .wwa-section .container,
          .layout-options-section .container,
          .why-choose-us-section .container {
            max-width: 1140px !important;
          }
        }
      `}</style>

    </>
  );
}

export default CompanyOverview;
